module.exports = __webpack_public_path__ + "static/media/scb-logo.9874101b.png";